import AccountService from '@/account/account.service';
import LoginService from '@/account/login.service';
import TranslationService from '@/locale/translation.service';
import { Component, Inject, Vue } from 'vue-property-decorator';

import EntitiesMenu from '@/entities/entities-menu.vue';

@Component({
  components: {
    'entities-menu': EntitiesMenu,
  },
})
export default class JhiNavbar extends Vue {
  @Inject('loginService')
  private loginService: () => LoginService;
  @Inject('translationService') private translationService: () => TranslationService;

  @Inject('accountService') private accountService: () => AccountService;
  public version = 'v' + VERSION;
  private currentLanguage = this.$store.getters.currentLanguage;
  private languages: any = this.$store.getters.languages;
  private hasAnyAuthorityValues = {};
  public manuals: Array<{ id: number; titleKey: string; link: string }> = [
    { id: 1, titleKey: 'perfil-unico.manual.userGuide', link: '/content/docs/Manual de usuario PFCAE.pdf' },
    { id: 2, titleKey: 'perfil-unico.manual.pmGuide', link: '/content/docs/Manual de usuario PM.pdf' },
    { id: 3, titleKey: 'perfil-unico.manual.subsedeGuide', link: '/content/docs/Manual de usuario subsede.pdf' },
    { id: 4, titleKey: 'perfil-unico.manual.pfGuide', link: '/content/docs/Preguntas Frecuentes PM-PFCAE.pdf' },
  ];

  created() {
    const currentLanguage = Object.keys(this.languages).includes(navigator.language) ? navigator.language : this.currentLanguage;
    this.translationService().refreshTranslation(currentLanguage);
  }

  public subIsActive(input) {
    const paths = Array.isArray(input) ? input : [input];
    return paths.some(path => {
      return this.$route.path.indexOf(path) === 0; // current path starts with this path string
    });
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }

  public logout(): Promise<any> {
    return this.loginService()
      .logout()
      .then(response => {
        this.$store.commit('logout');
        localStorage.removeItem('itemUserKey');
        window.location.href = response.data.logoutUrl;
        const next = response.data?.logoutUrl ?? '/';
        if (this.$route.path !== next) {
          return this.$router.push(next);
        }
      });
    return Promise.resolve(this.$router.currentRoute);
  }

  public openLogin(): void {
    this.loginService().login();
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public hasAnyAuthority(authorities: any): boolean {
    this.accountService()
      .hasAnyAuthorityAndCheckAuth(authorities)
      .then(value => {
        if (this.hasAnyAuthorityValues[authorities] !== value) {
          this.hasAnyAuthorityValues = { ...this.hasAnyAuthorityValues, [authorities]: value };
        }
      });
    return this.hasAnyAuthorityValues[authorities] ?? false;
  }

  public get openAPIEnabled(): boolean {
    return this.$store.getters.activeProfiles.indexOf('api-docs') > -1;
  }

  public get inProduction(): boolean {
    return this.$store.getters.activeProfiles.indexOf('prod') > -1;
  }

  public showDownloadModal(): void {
    this.$bvModal.show('download-modal');
  }

  public downloadManual(link: string): void {
    try {
      const a = document.createElement('a');
      a.href = link;
      const fileName = link.split('/').pop() || 'manual.pdf';
      a.setAttribute('download', fileName);
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } finally {
      this.$bvModal.hide('download-modal');
    }
  }

  public resetSelection(): void {
    this.$bvModal.hide('download-modal');
  }
}
